// ============================================================================
// OMS Availability — the procurement desk for placed orders.
//
// Successor to the legacy "Estimate Item Details" screen, for orders OMS owns.
// Everything here is one job: tell OMS where a line's goods are and how long the
// vendor needs, so it can allocate and raise the PO.
// ============================================================================
import { ClockCircleOutlined } from "@ant-design/icons";
import React from "react";
import styles from "../index.module.scss";
import AvailabilityQueue from "./queue";

const AvailabilityDashboard: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.header}>
      <ClockCircleOutlined className={styles.headerIcon} />
      <h2 className={styles.title}>OMS — Availability</h2>
    </div>
    <AvailabilityQueue />
  </div>
);

export default AvailabilityDashboard;
